import { Badge, Button, Table } from '@ui/themed';
import { t } from 'i18next';
import type { TeamApiResponse, TeamInviteApiResponse, TeamMemberApiResponse } from '../../types';
import { RoleBadge } from './member-role-badge';

export function AccountTeamsTable({
  team,
  isViewerOwner,
  rolesEnabled,
  onSwapOwner,
  onRemoveMember,
  onDeleteInvite,
}: {
  team: TeamApiResponse;
  isViewerOwner: boolean;
  rolesEnabled: boolean;
  onSwapOwner: (member: TeamMemberApiResponse) => void;
  onRemoveMember: (member: TeamMemberApiResponse) => void;
  onDeleteInvite: (invite: TeamInviteApiResponse) => void;
}) {
  const headings = rolesEnabled
    ? [
        t('features:account.components.members_table.headings.name'),
        t('features:account.components.members_table.headings.email'),
        t('features:account.components.members_table.headings.role'),
      ]
    : [
        t('features:account.components.members_table.headings.name'),
        t('features:account.components.members_table.headings.email'),
      ];

  return (
    <Table headings={headings} caption={t('features:account.components.members_table.caption')}>
      {team.users.map((user, i) => (
        <Table.Row key={user.id} id={user.id.toString()} index={i}>
          <Table.Cell>{user.name}</Table.Cell>
          <Table.Cell>{user.email}</Table.Cell>
          {rolesEnabled && (
            <Table.Cell>
              <RoleBadge role={user.role} />
            </Table.Cell>
          )}
          <Table.Cell sticky>
            {isViewerOwner && (
              <>
                <Button collapsible icon="edit" onClick={() => onSwapOwner(user)}>
                  {t('features:account.components.members_table.buttons.make_owner')}
                </Button>
                <Button
                  collapsible
                  icon="delete"
                  variant="dangerOutline"
                  onClick={() => onRemoveMember(user)}
                ></Button>
              </>
            )}
          </Table.Cell>
        </Table.Row>
      ))}
      {team.invites.map((invite, i) => (
        <Table.Row key={invite.id} id={invite.id.toString()} index={i}>
          <Table.Cell>
            <Badge variant="orange">
              {t('features:account.components.members_table.pending_invite_badge')}
            </Badge>
          </Table.Cell>
          <Table.Cell>{invite.email}</Table.Cell>
          {rolesEnabled && (
            <Table.Cell>
              <RoleBadge role={invite.role} />
            </Table.Cell>
          )}
          {isViewerOwner && (
            <Table.Cell sticky>
              <Button
                collapsible
                icon="delete"
                variant="dangerOutline"
                onClick={() => onDeleteInvite(invite)}
                disabled={invite.id < 0}
              ></Button>
            </Table.Cell>
          )}
        </Table.Row>
      ))}
    </Table>
  );
}
